<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="isLoading">
  <div
    style="
      position: fixed;
      z-index: 900;
      width: 100vw;
      height: 100vh;
      opacity: 80;
      top: 0;
      left: 0;
      background: #e8e8e880;
    "
  ></div>
  <mat-spinner class="spinner-center" style="z-index: 1000"></mat-spinner>
</div>

<div class="container">
  <div class="row mb-4">
    <div class="col-12 d-flex justify-content-center">
      <h1 class="lifedi-color" style="font-weight: 600">ระบบศูนย์เรียนรู้</h1>
    </div>
  </div>
  <div class="row justify-content-center mb-4">
    <div class="col-6">
      <input
        id="search-input"
        type="text"
        style="width: 100%"
        class="form-control search"
        placeholder="ค้นหาศูนย์เรียนรู้"
        name="searchName"
        [(ngModel)]="searchTerm"
        (keyup)="search()"
      />
    </div>
  </div>

  <div class="row mb-4">
    <div class="ml-auto col-4 d-flex justify-content-end">
      <button
        mat-flat-button
        style="background-color: rgb(0, 92, 61); color: #ffffff"
        (click)="handleOpenLearningCenterManage()"
      >
        เพิ่มศูนย์เรียนรู้ย่อย
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <nz-table
        #basicTable
        [nzBordered]="true"
        [nzData]="listOfData | async"
        [nzShowSizeChanger]="true"
      >
        <thead>
          <tr>
            <th
              *ngFor="let column of listOfColumn"
              [nzSortFn]="column.compare"
              [nzSortOrder]="column.orderBy"
              [nzSortDirections]="['ascend', 'descend']"
              class="text-center"
            >
              {{ column.title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data">
            <td>{{ data.CENTER_NAME }}</td>
            <td class="text-center">{{ data.CREATE_DATE | dateTime }}</td>
            <td class="text-center">{{ data.CREATE_BY }}</td>
            <td class="text-center">
              <nz-switch
                [ngModel]="data.VIEW_STATUS"
                (ngModelChange)="changeStatus(data.CENTER_ID, data.VIEW_STATUS)"
              ></nz-switch>
            </td>
            <td class="text-center">
              <a
                nz-button
                nzType="text"
                (click)="handleOpenLearningCenterEditor(data.CENTER_ID)"
              >
                <span nz-icon nzType="select" nzTheme="outline"></span>
              </a>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
